export default __webpack_public_path__ + "static/media/rentyWhiteIcon.e279f21b.svg";